export type KnowledgeServiceErrorCode =
  | "cancelled"
  | "invalid-input"
  | "not-found"
  | "conflict"
  | "integrity"
  | "io";

export class KnowledgeServiceError extends Error {
  readonly code: KnowledgeServiceErrorCode;
  readonly details: Readonly<Record<string, unknown>>;

  constructor(
    code: KnowledgeServiceErrorCode,
    message: string,
    details: Readonly<Record<string, unknown>> = {},
    options?: ErrorOptions,
  ) {
    super(message, options);
    this.name = "KnowledgeServiceError";
    this.code = code;
    this.details = details;
  }
}

export class OperationCancelledError extends KnowledgeServiceError {
  constructor() {
    super("cancelled", "The operation was cancelled.");
    this.name = "OperationCancelledError";
  }
}

export function throwIfCancelled(signal?: AbortSignal): void {
  if (signal?.aborted) {
    throw new OperationCancelledError();
  }
}

export interface ProgressEvent {
  phase: string;
  completed: number;
  total?: number;
  message?: string;
}

export interface OperationContext {
  signal?: AbortSignal;
  onProgress?: (event: ProgressEvent) => void;
}

export function reportProgress(
  context: OperationContext | undefined,
  event: ProgressEvent,
): void {
  throwIfCancelled(context?.signal);
  context?.onProgress?.(event);
}
